import React from "react";
import PropTypes from "prop-types";
import ResizedImage from "theme/components/atoms/ResizedImage";
import { injectIntl, defineMessages } from "react-intl";
import { RoundIconButton } from "theme/components/atoms/Button";
import classnames from "classnames";

const messages = defineMessages({
  previous: {
    id: "modules.ProductView.ImagesGallery.previous",
    defaultMessage: "Previous",
  },
  next: {
    id: "modules.ProductView.ImagesGallery.next",
    defaultMessage: "Next",
  },
});

const ImagesGallery = ({
  images,
  name,
  onImageClick,
  setStartIndex,
  hasPrev,
  hasNext,
  intl,
  startIndex,
  currentIndex,
  haveSlider,
}) => (
  <div className="product__gallery__slider">
    <div className="product__gallery__slider--prev">
      {haveSlider && (
        <RoundIconButton
          state={!hasPrev ? "disabled" : null}
          onDisableClick={() => {}}
          onClick={() => setStartIndex(startIndex - 1)}
          icon="chevron-left"
          iconSize="tiny"
          title={intl.formatMessage(messages.previous)}
        />
      )}
    </div>
    {images.map((image, index) => {
      const className = classnames("product__gallery__slider__image", {
        "product__gallery__slider__image--active": index === currentIndex,
      });
      return (
        <div key={image.id} className={className}>
          <ResizedImage
            src={image.file}
            alt={image.alt || name}
            onClick={() => onImageClick(index)}
            format="thumbnailMediaGalery"
            appearance="full"
          />
        </div>
      );
    })}
    <div className="product__gallery__slider--next">
      {haveSlider && (
        <RoundIconButton
          state={!hasNext ? "disabled" : null}
          onDisableClick={() => {}}
          onClick={() => setStartIndex(startIndex + 1)}
          icon="chevron-right"
          iconSize="tiny"
          title={intl.formatMessage(messages.next)}
        />
      )}
    </div>
  </div>
);

ImagesGallery.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.any.isRequired,
      file: PropTypes.string.isRequired,
    })
  ).isRequired,
  name: PropTypes.string,
  onImageClick: PropTypes.func,
  hasPrev: PropTypes.bool,
  hasNext: PropTypes.bool,
  setStartIndex: PropTypes.func,
};

export default injectIntl(ImagesGallery);
